import { render, staticRenderFns } from "./LoggerComponentsPage.vue?vue&type=template&id=f2f9ca3c&scoped=true&"
import script from "./LoggerComponentsPage.vue?vue&type=script&lang=ts&"
export * from "./LoggerComponentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./LoggerComponentsPage.vue?vue&type=style&index=0&id=f2f9ca3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f9ca3c",
  null
  
)

export default component.exports